var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25.1528C50 11.2613 38.8071 0 25 0C11.1929 0 0 11.2613 0 25.1528C0 37.7071 9.14209 48.1131 21.0938 50V32.4235H14.7461V25.1528H21.0938V19.6113C21.0938 13.3074 24.8262 9.82531 30.5366 9.82531C33.271 9.82531 36.1328 10.3166 36.1328 10.3166V16.5065H32.9805C29.875 16.5065 28.9062 18.4455 28.9062 20.4366V25.1528H35.8398L34.7314 32.4235H28.9062V50C40.8579 48.1131 50 37.7071 50 25.1528Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.bec52c914f4b8f5718f013cc646cc9e9.svg";
export { ForwardRef as ReactComponent };